import IMask from 'imask';
import PersonTypeService from '@transfeeradev/api-services/PersonTypeService';
import CpfCnpjBlacklistService from '@transfeeradev/api-services/CpfCnpjBlacklistService';
import { regexes } from '@transfeeradev/api-enums';
import { normalizeDocument } from '@/commons/formatters/document';

const MASKS = [{ mask: '000.000.000-00' }, { mask: 'AA.AAA.AAA/AAAA-00', definitions: { A: /[0-9a-zA-Z]/ } }];

const dispatch = (appended, dynamicMasked) => {
  const raw = (dynamicMasked.value + appended).replace(/[./-]/g, '');
  const isCnpj = /[a-zA-Z]/.test(raw) || raw.replace(/\D/g, '').length > 11;
  return dynamicMasked.compiledMasks[isCnpj ? 1 : 0];
};

export const createMask = inputElement => IMask(inputElement, { mask: MASKS, dispatch });

export const validateCpfCnpj = async (rawValue, { checkBlacklist, getBlacklist } = {}) => {
  const cpfCnpj = normalizeDocument(rawValue);
  const hasLetters = /[A-Z]/.test(cpfCnpj);

  const isValid = hasLetters
    ? regexes.CNPJ.test(cpfCnpj)
    : Boolean(PersonTypeService.isValidCPF(cpfCnpj) || PersonTypeService.isValidCNPJ(cpfCnpj));

  if (!isValid) {
    return { isValid: false };
  }

  if (checkBlacklist && typeof getBlacklist === 'function') {
    const blacklist = await getBlacklist();
    return CpfCnpjBlacklistService.validate(cpfCnpj, blacklist);
  }

  return { isValid: true };
};
